export const GET_CONSUMPTION_PENDING_REQUEST =
  "GET_CONSUMPTION_PENDING_REQUEST";
export const GET_CONSUMPTION_PENDING_SUCCESS =
  "GET_CONSUMPTION_PENDING_SUCCESS";
export const GET_CONSUMPTION_PENDING_FAILURE =
  "GET_CONSUMPTION_PENDING_FAILURE";

export const GET_BOOKING_STATION_REQUEST = "GET_BOOKING_STATION_REQUEST";
export const GET_BOOKING_STATION_SUCCESS = "GET_BOOKING_STATION_SUCCESS";
export const GET_BOOKING_STATION_FAILURE = "GET_BOOKING_STATION_FAILURE";
